import React from "react";
import clsx from "clsx";

type PaperProps = {
    children: React.ReactNode;
    className?: string;
    style?: React.CSSProperties;
    elevation?: 0 | 1 | 2 | 3 | 4 | 5;
    padding?: "none" | "sm" | "md" | "lg" | "xl";
    rounded?: "none" | "sm" | "md" | "lg" | "xl" | "2xl" | "full";
    border?: boolean;
    background?: "white" | "gray" | "light";
};

const elevationMap = {
    0: "shadow-none",
    1: "shadow-sm",
    2: "shadow",
    3: "shadow-md",
    4: "shadow-lg",
    5: "shadow-xl",
};

const paddingMap = {
    none: "p-0",
    sm: "p-2",
    md: "p-4",
    lg: "p-6",
    xl: "p-8",
};

const roundedMap = {
    none: "rounded-none",
    sm: "rounded-sm",
    md: "rounded-md",
    lg: "rounded-lg",
    xl: "rounded-xl",
    "2xl": "rounded-2xl",
    full: "rounded-full",
};

const bgMap = {
    white: "bg-white",
    gray: "bg-gray-100",
    light: "bg-gray-50",
};

const Paper: React.FC<PaperProps> = ({
                                         children,
                                         className,
                                         style,
                                         elevation = 2,
                                         padding = "md",
                                         rounded = "xl",
                                         border = false,
                                         background = "white",
                                     }) => {
    return (
        <div
            style={style}
            className={clsx(
                bgMap[background],
                elevationMap[elevation],
                paddingMap[padding],
                roundedMap[rounded],
                border && "border border-gray-200",
                className
            )}
        >
            {children}
        </div>
    );
};

export default Paper;
